import React from "react";
import {
  AvatarGroup as MUIAvatarGroup,
  AvatarGroupProps,
  SxProps,
} from "@mui/material";
import { useTheme } from "contexts";

type Props = Omit<AvatarGroupProps, "sx"> & {
  size?: "small" | "medium" | "large";
  children?: React.ReactNode[];
  sx?: SxProps; // Allow additional styling overrides
};

export const AvatarGroup = React.forwardRef<HTMLDivElement, Props>(
  ({ children, size = "medium", sx, ...props }, ref) => {
    const { theme } = useTheme();
    const avatarSize = size === "small" ? 24 : size === "medium" ? 32 : 48;

    // Define the custom styles
    const avatarStyles: SxProps = {
      "& .MuiAvatar-root": {
        width: avatarSize,
        height: avatarSize,
        fontSize: theme.font.xs,
        color: theme.color.primary.textAccent,
        backgroundColor: theme.color.primary.accent,
      },
      ...sx, // Allow overriding styles with sx prop
    };

    return (
      <MUIAvatarGroup {...props} ref={ref} sx={avatarStyles}>
        {children}
      </MUIAvatarGroup>
    );
  }
);
